import {createAction} from "@reduxjs/toolkit";
import {EDIT_LOGO, GET_LOGO, SET_LOGO, SET_SETTING_STATE} from "./consts";

export const settingAction = {
	getLogo: createAction(GET_LOGO, (payload) => ({payload})),
	setLogo: createAction(SET_LOGO, (payload) => ({payload})),
	setSettingState: createAction(SET_SETTING_STATE, (payload) => ({ payload })),
	editLogo: createAction(EDIT_LOGO, (payload) => ({payload}))
}